import { desc } from "framer-motion/client";

export const menuItems = {
  tapas: [
    {
      name: {
        en: "Presunto (L, G) ",
        fi: "Presunto (L, G) ",
      },
      description: {
        en: "Thinly sliced dry-cured ham, full of flavor.",
        fi: "Ohueksi viipaloitua ilmakuivattua kinkkua, täynnä makua.",
      },
      price: 2.9,
    },
    {
      name: {
        en: "Prato de Tapas ",
        fi: "Prato de Tapas) ",
      },
      description: {
        en: "Petiscos / Tapas setti",
        fi: "Petiscos / Tapas setti",
      },
      price: 9.5,
    },
    {
      name: {
        en: "Juustolajitelma / Queijos (G) 	",
        fi: "Juustolajitelma / Queijos (G) 	",
      },
      description: {
        en: "Cheese perfect for pairing with wine.",
        fi: "Juusto, joka täydentää viinin täydellisesti.",
      },
      price: 2.5,
    },
    {
      name: {
        en: "Marinoidut Oliivit / Azeitonas (L, G, V)  ",
        fi: "Marinoidut Oliivit / Azeitonas (L, G, V)  ",
      },
      description: {
        en: "A mix of marinated olives, a Mediterranean classic.",
        fi: "Sekoitus marinoituja oliiveja, välimerellinen klassikko.",
      },
      price: 2.5,
    },
    {
      name: {
        en: "Leipä / pão (L) 	",
        fi: "Leipä / pão (L) 	",
      },
      description: {
        en: "Freshly baked artisan bread, served with Butter.",
        fi: "Tuoretta vastaleivottua artesaanileipää, tarjoiltuna voi kanssa.",
      },
      price: 2.5,
    },
  ],
  starters: [
    {
      name: {
        en: "Turskakroketit /  Pastéis de Bacalhau (M, S) ",
        fi: "Turskakroketit /  Pastéis de Bacalhau (M, S) ",
      },
      description: {
        en: "Crispy breaded croquette filled with tender cod, served with a delicious dipping sauce.",
        fi: "Rapeaksi leivitetty kroketti, joka on täynnä mureaa turskaa, tarjoillaan herkullisen dippikastikkeen kera.",
      },
      price: 10.5,
    },
    {
      name: {
        en: "Grillatut Tiikeriravut / Gambas Grelhados (L, G, S)",
        fi: "Grillatut Tiikeriravut / Gambas Grelhados (L, G, S)",
      },
      description: {
        en: "Grilled tiger prawns with olive oil and chef’s special spices, served with artisanal bread.",
        fi: "Grillatut tiikeriravut oliiviöljyllä ja chef’in mausteilla, tarjottuna artesaanileivän kera.",
      },
      price: 12.9,
    },
    {
      name: {
        en: "Tiradito de Atum (L, G, M)  ",
        fi: "Tiradito de Atum (L, G, M) ",
      },
      description: {
        en: "Seared tuna slices served with the chef’s special sauce and red onion, coated with sesame seeds.",
        fi: "Paistettua tonnikalaa viipaleina, tarjoiltuna kokin erikoiskastikkeen ja punasipulin kanssa. Päällystetty seesaminsiemenillä .",
      },
      price: 10.5,
    },
    {
      name: {
        en: "Atlantin Simpukat / Atlantic Clams (L, G, S)  ",
        fi: "Atlantin Simpukat / Atlantic Clams (L, G, S)  ",
      },
      description: {
        en: "Fresh Atlantic clams cooked with lemon juice, offering a vibrant and tangy taste of the ocean.",
        fi: "Tuoreet Atlantin simpukat, kypsennettynä sitruunamehulla, joka tuo raikkaan ja happaman maun.",
      },
      price: 11.9,
    },
    {
      name: {
        en: "Caldo Verde (L, G, V, N) 	",
        fi: "Caldo Verde (L, G, V, N) 	 ",
      },
      description: {
        en: "A traditional Portuguese green soup made with kale and potatoes.",
        fi: "Perinteinen portugalilainen vihreä keitto, joka on valmistettu lehtikaalista ja perunoista. Tarjoillaan ohuiksi viipaloidun savuisen Chouriço-makkaran kera. Saatavilla myös kasvisvaihtoehtona ilman Chouriçoa.",
      },
      price: 9.9,
    },
    {
      name: {
        en: "Sopa de Salmão / Salmon Soup (L, G, N) 	",
        fi: "Sopa de Salmão / Salmon Soup (L, G, N) 	",
      },
      description: {
        en: "A rich and flavorful /creamy salmon soup with fresh herbs.",
        fi: "Kermainen / lohikeitto täynnä makua ja tuoreita yrttejä.",
      },
      price: 9.9,
    },
    {
      name: {
        en: "Pastel Kasvisinho ( L, G, V, N )",
        fi: "Pastel Kasvisinho ( L, G, V, N )",
      },
      description: {
        en: "Small vegetable fritters, seasoned and deep-fried until crispy. Served with our homemade dip.",
        fi: "Kasvisfrittereitä, maustettuja ja rapeaksi friteerattuja. Tarjoillaan talon dipin kanssa.",
      },
      price: 12.9,
    },
  ],
  salads: [
    {
      name: {
        en: "Kvinoa-salaatti / Quinoa Salad (V, L, G, M, N)",
        fi: "Kvinoa-salaatti / Quinoa Salad (V, L, G, M, N)",
      },

      description: {
        fi: "Terveellinen sekoitus kvinoaa, porkkanaa, makeaa maissia ja kokin erikoiskastiketta.",
        en: "A healthy mix of quinoa, carrots, sweet corn, and the chef’s special sauce.",
      },

      price: 11.9,
    },
    {
      name: {
        en: "Mustekalasalaatti / Salada de Polvo (L, G)",
        fi: "Mustekalasalaatti / Salada de Polvo (L, G)",
      },

      description: {
        fi: "Mustekalaa tuoreiden salaattien, kirsikkatomaattien ja Kalamata-oliivien kera, viimeistelty raikkaalla sitruunavinaigretillä. Aito Välimeren makuelämys.",
        en: "Tender octopus with fresh greens, cherry tomatoes, and Kalamata olives, dressed in a zesty lemon vinaigrette. A true taste of the Mediterranean.",
      },
      price: 16.9,
    },

    {
      name: {
        en: "Välimeren Herkku / Mediterranean Delight (G, N)",
        fi: "Välimeren Herkku / Mediterranean Delight (G, N)",
      },

      description: {
        fi: "Rapeaa salaattia, kirsikkatomaatteja, parmesaania, oliiveja ja höystettynä pikkelöidyllä porkkanalla ja punasipulilla, päälle grillattua halloumia.",
        en: "Crisp lettuce, cherry tomatoes, parmesan, olives enhanced with pickled carrot and onion, topped with grilled halloumi.",
      },
      price: 13.9,
    },
  ],

  mains: [
    {
      name: {
        en: "Grillattu Atlantin Mustekala / Polvo à lagareiro (L, S)",
        fi: "Grillattu Atlantin Mustekala / Polvo à lagareiro (L, S)",
      },

      description: {
        fi: "Grillattu Atlantin mustekala tarjoiltunapaahdettujen perunoiden,kermaisen perunamuusin, kultaisen maissileipäkuorrutteen ja tuoreen persiljan kanssa.",
        en: "Grilled Atlantic octopus served with roasted potatoes, creamy mashed potatoes, a golden cornbread topping, and fresh parsley on top.",
      },
      price: 24.9,
    },
    {
      name: {
        en: "Bacalhau com Nata(L, G, N)",
        fi: "Bacalhau com Nata(L, G, N)",
      },

      description: {
        fi: "Perinteinen portugalilainen ruoka, jossa suolattua turskaa haudutetaan kermasessa kastikkeessa kastikkeessa perunan ja sipulin kanssa, gratinoituna kullanruskeaksi.",
        en: "A traditional Portuguese dish where salted cod is stewed in a creamy sauce with potatoes and onions, finished with a golden crust.",
      },
      price: 19.9,
    },
    {
      name: {
        en: "Alentejon makuja: Porsasta ja simpukoita / Carne de Porco (G, L, S)",
        fi: "Alentejon makuja: Porsasta ja simpukoita / Carne de Porco (G, L, S)",
      },

      description: {
        fi: "Mureaa porsaanlihaa ja mehveä simpukoita aromaattisessa valkoviini- alkoholikastikkeessa, tarjoiltuna rapeiden kultaperunoiden ja tuoreiden vihannesten kera.",
        en: "Tender pork and succulent clams gently simmered in a fragrant white wine and garlic sauce, served with crispy golden potatoes and a touch of fresh coriander.",
      },
      price: 16.5,
    },
    {
      name: {
        en: "Perinteinen Portugalilainen Merenelävien Riisi Traditional Portuguese Seafood Rice / Arroz de Marisco (L, S) 38 € (2 hlö)",
        fi: "Perinteinen Portugalilainen Merenelävien Riisi Traditional Portuguese Seafood Rice / Arroz de Marisco (L, S) 38 € (2 hlö)",
      },

      description: {
        fi: "Hitaasti haudutettu portugalilainen merenelävien riisiruoka, valmistettu Atlantin tuoreista merenelävistä, yrteistä ja täyteläisestä marisco-kastikkeesta – todellinen sabor do mar.",
        en: "A slow-cooked, rich and flavorful Portuguese seafood rice dish made with fresh Atlantic seafood, herbs, and a creamy marisco sauce – a true sabor do mar.",
      },

      price: 20,
    },
    {
      name: {
        en: "Golden chicken ( Frango Dourado)",
        fi: "Golden chicken ( Frango Dourado)",
      },
      description: {
        fi: "Rapea leivitetty kana, tarjoiltuna ranskalaisten ja tuoreen salaatin kanssa.",
        en: "Crispy breaded chicken, served with fries and a fresh salad.",
      },
      price: 14.9,
    },
    {
      name: {
        en: "Porsaan Bitoque /Bitoque de Porco (L) ",
        fi: "Porsaan Bitoque /Bitoque de Porco (L)",
      },

      description: {
        fi: "Mehevä Porsaanpihvi tarjoillaan rapeiden ranskalaisten, täydellisesti paistetun kananmunan ja tuoreen salaattin kera.",
        en: "Juicy pork steak with fries, fried egg, and a fresh garden salad.",
      },
      price: 15.9,
    },

    {
      name: {
        en: "Grillattu Turska / Bacalhau Grelhado (L, G, M)",
        fi: "Grillattu Turska / Bacalhau Grelhado (L, G, M)",
      },
      description: {
        fi: "Grillattu Atlantin turska Tarjoillaan yrttikastikkeen, paahdettujen perunoiden, kermaisen perunamuusin ja tuoreiden kauden vihannesten kera.",
        en: "Grilled Atlantic Cod fish Served with herb sauce, roasted potatoes, mashed potatoes, and fresh seasonal vegetables.",
      },
      price: 20.9,
    },

    {
      name: {
        en: "Bacalhau à Brás(L, G, M, N)",
        fi: "Bacalhau à Brás(L, G, M, N)",
      },
      description: {
        fi: "Perinteinen portugalilainen ruokalaji, jossa suolattua turskaapaistetaan rapeiden perunoiden, sipulin ja munien kanssa,koristeltuna persiljalla ja oliiveilla.",
        en: "A traditional Portuguese dish, where salted cod is sautéed with crispy potatoes, onions, and eggs, garnished with parsley and olives.",
      },
      price: 19.9,
    },
    {
      name: {
        en: "Grilled Salmon (Salmao Assado)  (G, M, N)",
        fi: "Grilled Salmon (Salmao Assado) (G, M, N)",
      },
      description: {
        fi: "Grillattu lohi, tarjoiltuna vihannesten, perunamuusin ja paahdettujen perunoiden kanssa – maukas ja ravitseva ateria!",
        en: "Grilled salmon, paired with vegetables, mashed potatoes and roasted Potatoes for a rich, healthy meal full of flavors.",
      },
      price: 18.9,
    },
    {
      name: {
        en: "Grillattu Meribassi /Dourada Grelhada (L, G)",
        fi: "Grillattu Meribassi /Dourada Grelhada (L, G) ",
      },
      description: {
        fi: "Täydellisesti grillattu meribassi, tarjoiltuna kauden vihanneksilla,samettisella perunamuusilla ja rapeilla paahdetuilla perunoilla.",
        en: "Perfectly grilled sea bream, served with seasonal vegetables, velvety mashed potatoes, and crispy roasted potatoes.",
      },
      price: 21.9,
    },

    {
      name: {
        en: "Atlantic Shrimp Risotto (Risotto de Camarão Atlantico) ( S) ",
        fi: "Atlantic Shrimp Risotto (Risotto de Camarão Atlantico) ( S) ",
      },

      description: {
        fi: "Kermainen risotto Atlantin katkaravuilla, luoden täyteläisen ja herkullisen ruoan, joka on täynnä meren makuja.",
        en: "Creamy risotto with Atlantic shrimp, creating a rich and indulgent dish full of flavors from the sea.",
      },
      price: 17.9,
    },
    {
      name: {
        en: "Piri Piri Chicken / Frango Piri Piri  (L, G, M, N)",
        fi: "Piri Piri Chicken / Frango Piri Piri  (L, G, M, N)",
      },

      description: {
        fi: "Mehevä grillikana aidossa portugalilaisessa Piri Piri -kastikkeessa ja chililasitteessa. Tarjoillaan riisin tai rapeiden ranskalaisten ja tuoreen salaatin kera.",
        en: "Juicy grilled chicken in authentic Portuguese Piri Piri sauce with a spicy chili glaze. Served with rice or crispy fries and a fresh salad.",
      },
      price: 15.9,
    },
    {
      name: {
        en: "Kasviskvinoa /Quinoa Vegetarian (V, L, G, M, N) ",
        fi: "Kasviskvinoa /Quinoa Vegetarian (V, L, G, M, N) ",
      },

      description: {
        fi: "Värikäs ja ravitseva kvinoa tomaattikastikkeella ja kauden vihanneksilla.",
        en: "Colorful and nutritious quinoa with tomato cream and seasonal vegetable topped.",
      },
      price: 14.9,
    },
    {
      name: {
        en: "Grillattu Halloumi Kvinoa / Grilled Halloumi Quinoa (G, N)",
        fi: "Grillattu Halloumi Kvinoa / Grilled Halloumi Quinoa (G, N)",
      },

      description: {
        fi: "Kvinoa tomaattikastikkeella, viimeistelty grillatulla halloumilla ja sitruunalla.",
        en: "Quinoa with tomato cream, topped with grilled halloumi and lemon.",
      },
      price: 15.9,
    },
    {
      name: {
        en: "Halloumi Risotto  (L, G,V, M, N)",
        fi: "Halloumi Risotto  (L, G,V, M, N)",
      },

      description: {
        fi: "Kermainen risotto, jossa täydellisesti grillattua halloumia ja ripaus sitruunaa,koristeltuna tuoreilla yrteillä, kevyeksi ja maukkaaksi ruokalajiksi.",
        en: "A creamy risotto with perfectly grilled halloumi and a hint of lemon, topped with fresh herbs for a light and flavorful dish.",
      },
      price: 19.9,
    },

    {
      name: {
        en: "Spaghetti Carbonara",
        fi: "Spaghetti Carbonara ",
      },

      description: {
        fi: "Kermaisen täyteläinen carbonara, valmistettu pancettasta,kananmunan keltuaisesta ja parmesanjuustosta.",
        en: "Creamy and rich carbonara pasta made with pancetta/ bacon, egg yolk,and parmesan cheese.",
      },
      price: 15.9,
    },
    {
      name: {
        en: "Arroz de Feijão portugalilainen papuriisi ( L, G, N, V)",
        fi: "Arroz de Feijão portugalilainen papuriisi ( L, G, N, V)",
      },

      description: {
        fi: "Samettinen riisi punaisilla pavuilla, valkosipulilla ja yrteillä vaatimaton ruoka, joka tuo esiin Portugalin aidon olemuksen.",
        en: "Velvety rice with red beans, garlic, and herbs – a humble dish that brings out the true essence of Portugal.",
      },
      price: 13.9,
    },
  ],

  desserts: [
    {
      name: {
        en: "Crème Brûlée",
        fi: "Crème Brûlée",
      },
      description: {
        en: "A classic dessert made with creamy custard, egg, sugar, and vanilla, topped with a crispy sugar crust that cracks beautifully with a spoon.",
        fi: "Perinteinen jälkiruoka, joka on valmistettu kermaisesta vanukkaasta, munasta, sokerista ja vaniljasta, päällä rapea sokerikuori, joka murtuu kauniisti lusikalla.",
      },
      price: 7.9,
    },

    {
      name: {
        en: "Jäätelöä ",
        fi: "Jäätelöä ",
      },
      description: {
        en: "",
        fi: "",
      },
      price: 5.9,
    },

    {
      name: {
        en: "Pastel de Nata",
        fi: "Pastel de Nata",
      },
      description: {
        en: "",
        fi: "",
      },
      price: 5,
    },


  ],
  drinks: [
    {
      name: {
        price: 32.9,
        en: "Sangria Tinto (Red Sangria)-1L - €32.90, 1.7L - €45.90",
        fi: "Sangria Tinto (Red Sangria)-1L - €32.90, 1.7L - €45.90",
      },
      description: {
        en: "A refreshing blend of red wine, fruits, rum,sugar, seven up ,beer and vodka.(Raikas sekoitus punaviiniä, hedelmiä, rommia ja vodkaa.)",
        fi: "A refreshing blend of red wine, fruits, rum,sugar, seven up ,beer and vodka.(Raikas sekoitus punaviiniä, hedelmiä, rommia ja vodkaa.)",
      },
      price: 32.9,
    },
    {
      name: {
        en: "Sangria Branca (White Sangria): 1L - €32.90, 1.7L - €45.90",
        fi: "Sangria Branca (White Sangria):1L - €32.90, 1.7L - €45.90",
      },
      description: {
        en: "A crisp blend of white wine, fruits, rum,sugar,seven up ,beer and vodka.(Raikas sekoitus valkoviiniä, hedelmiä, rommia ja vodkaa.)",
        fi: "A crisp blend of white wine, fruits, rum,sugar,seven up ,beer and vodka.(Raikas sekoitus valkoviiniä, hedelmiä, rommia ja vodkaa.)",
      },
      price: 32.9,
    },
  ],
};
